import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { BsModalModule } from 'ng2-bs3-modal';
import { UserModule } from './modules/user/user.module';
import { AuthModule } from './modules/auth/auth.module';
import { AppGatewayComponent } from './core/appgateway.component';
import { AuthGuard } from './core/guards/auth.guard';
import { NoAccessComponent } from './core/no-access/no-access.component';
import { EDocketsToeFilingComponent } from './modules/e-dockets-toe-filing/e-dockets-toe-filing.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard', canActivate: [AuthGuard] },
  { path: 'dashboard', loadChildren: './modules/dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'auth', redirectTo: 'dashboard', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'new-filing', loadChildren: 'app/modules/new-filing/new-filing.module#NewFilingModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'products', loadChildren: 'app/modules/products/products.module#ProductsModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'product-efiling', loadChildren: 'app/modules/product-efiling/product-efiling.module#ProductEfilingModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'user', loadChildren: 'app/modules/user/user.module#UserModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'subsequent', loadChildren: 'app/modules/subsequent-filing/subsequent-filing.module#SubsequentfilingModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'drafts', loadChildren: 'app/modules/drafts/drafts.module#DraftsModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'recent-filings', loadChildren: 'app/modules/recent-filings/recent-filings.module#RecentFilingsModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'completed-filings', loadChildren: 'app/modules/completed-filings/completed-filings.module#CompletedFilingsModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'billing-reports', loadChildren: 'app/modules/billing-reports/billing-reports.module#BillingReportsModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'displayorder', loadChildren: 'app/modules/displayorder/displayorder.module#DisplayOrderModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'services', loadChildren: 'app/modules/services/services.module#ServicesModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'profile', loadChildren: 'app/modules/profile/profile.module#ProfileModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
 // { path: 'order-update', loadChildren: 'app/modules/order-update/order-update.module#OrderUpdateModule', canActivate: [AuthGuard] },
  { path: 'manage-firm-payment', loadChildren: 'app/modules/manage-firm-payment/manage-firm-payment.module#ManageFirmPaymentModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },  
  { path: 'manage-tyler-registrations', loadChildren: 'app/modules/manage-tyler-registrations/manage-tyler-registrations.module#ManageTylerRegistrationsModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },  
  { path: 'settings', loadChildren: 'app/modules/setting/setting.module#SettingModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'appgateway/:landingpage', component: AppGatewayComponent, pathMatch: 'full' },
  { path: 'appgateway/:landingpage/:dashboard', component: AppGatewayComponent, pathMatch: 'full' },
  { path: 'no-access', component: NoAccessComponent, pathMatch: 'full' },
  { path: 'pages', loadChildren: './main/pages/pages.module#PagesModule' },
  //{ path: 'user-management', loadChildren: './modules/user-management/user-management.module#UserManagementModule', canActivate: [AuthGuard] },
  { path: 'firm-management', loadChildren: './modules/firm-management/firm-management.module#FirmManagementModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'maintain-payment', loadChildren:'./modules/maintain-payments/maintain-payment.module#MaintainPaymentModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: 'update-payment', loadChildren:'./modules/maintain-payments/update-payment-account.module#UpdatePaymentModule', canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path:'edockets/filing', pathMatch: 'full', component:EDocketsToeFilingComponent,canActivate: [AuthGuard], canLoad: [AuthGuard]}
];


@NgModule({
  imports: [
      BsModalModule,
      UserModule,
      AuthModule,
      RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload',
        preloadingStrategy: PreloadAllModules
      })
    ],
  exports: [RouterModule],
  providers: [
    AuthGuard
  ]
})
export class
  AppRoutingModule {
}
